const CONFIG = {
  URL: "https://un-api.eventqiu.com/api",
};


// https://Ffunventionqiu.jagoan.info/api/admin/add
// / https://unqiu.jagoan.info/api
export default CONFIG;
